import { Routes } from "@angular/router";

import { PermitHandleFlammableAtexRequestComponent } from "./permit-create/components/permit-handle-flammable-atex-request/permit-handle-flammable-atex-request.component";
import { PermitCreateComponent } from "./permit-create/components/permit-create/permit-create.component";
import { PreparePermitComponent } from "./permit-create/components/prepare-permit/prepare-permit.component";
import { PermitRequestFlammableAtexComponent } from "./permit-create/components/permit-request-flammable-atex/permit-request-flammable-atex.component";
import { ExportPermitComponent } from "./permit-details/components/export-permit/export-permit.component";
import { PermitRequestListComponent } from "./permit-list/components/permit-request-list/permit-request-list.component";
import { PreparedPermitListComponent } from "./permit-list/components/prepared-permit-list/prepared-permit-list.component";
import { PermitPaths } from "./permit-paths";
import { PermitRootComponent } from "./permit-root/components/permit-root.component";
import { PermitComponent } from "./permit/components/permit/permit.component";

export const routes: Routes = [{
    path: "",
    component: PermitRootComponent,
    data: { title: "Tillstånd" },
}, {
    path: PermitPaths.PermitRequests,
    component: PermitRequestListComponent,
    data: { title: "Tillståndsbegäranden" },
}, {
    path: PermitPaths.PreparedPermits,
    component: PreparedPermitListComponent,
    data: { title: "Förberedda tillstånd" },
}, {
    path: PermitPaths.Create,
    component: PermitCreateComponent,
    data: { title: "permit.createNew" },
}, {
    path: PermitPaths.CreateDemo,
    component: PermitCreateComponent,
    data: { title: "permit.createNewDemo" },
}, {
    path: `${PermitPaths.HandleFlammableAtexPermitRequest}/:permitId`,
    component: PermitHandleFlammableAtexRequestComponent,
    data: { title: "permit.handleFlammableAtexPermitRequest.loading" },
}, {
    path: `${PermitPaths.RequestFlammableAtexPermit}/:permitId`,
    component: PermitRequestFlammableAtexComponent,
    data: { title: "permit.requestFlammableAtexPermit.heading" },
}, {
    path: `${PermitPaths.RetrieveFlammableAtexPermit}/:permitId`,
    component: PreparedPermitListComponent,
    data: { title: "permit.retrieveFlammableAtexPermit.heading", retrieveFlammableAtexPermit: true },
}, {
    path: PermitPaths.Prepare,
    component: PreparePermitComponent,
    data: { title: "Förbered tillstånd" },
    children: [{
        path: "",
        children: [{
            path: ":permitId",
            component: PreparePermitComponent,
            data: { autoBreadcrumbsDisabled: true },
        }],
    }],
}, {
    path: ":permitId",
    data: { title: "Tillstånd" },
    children: [{
        path: "",
        children: [{
            path: "",
            component: PermitComponent,
        }, {
            path: PermitPaths.Pdf,
            component: ExportPermitComponent,
            data: { autoBreadcrumbsDisabled: true },
        }],
    }],
}];
